export default function chooseRandomly(a: any[]) {
  return a[Math.floor(Math.random() * a.length)]
}
